var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._t("default"),(!_vm.isRequired)?_c('span',[_vm._v(" (opcjonalnie)")]):_c('sup',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(": ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }